import module from '@kendu/ui/module'
import './style.scss'

export class KdTableHeaderComponent {}

module.component('kdTableHeader', {
  controller: KdTableHeaderComponent,
  restrict: 'E',
})



// WEBPACK FOOTER //
// ./src/kendu/ui/components/kd-table/header/component.js